import Checkbox from '../../../components/ReusableComponents/Checkbox/index'
import styles from './HotelNumber.module.scss'

const HotelNumber = ({ number, location, toggleNumber, checked }) => {
  return (
    <label className={styles.container}>
      <div className={styles.checkBoxContainer}>
        <Checkbox checked={checked} onChange={() => toggleNumber(number)} />
      </div>
      <div className={styles.infoHolder}>
        <p>{number}</p>
        <span>{location}</span>
      </div>
    </label>
  )
}
export default HotelNumber
